import React from 'react';
import type { BombiixIconProps } from './types';

/** Bombiix Bullet Points Empty icon. Exported from Figma (Bombiix 2026). */
const BulletPointsEmptyIcon: React.FC<BombiixIconProps> = ({ size = 20, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...rest}>
    <path
      d="M16 10C16 6.68629 13.3137 4 10 4C6.68629 4 4 6.68629 4 10C4 13.3137 6.68629 16 10 16V17C6.13401 17 3 13.866 3 10C3 6.13401 6.13401 3 10 3C13.866 3 17 6.13401 17 10C17 13.866 13.866 17 10 17V16C13.3137 16 16 13.3137 16 10Z"
      fill="currentColor"
    />
  </svg>
);

export default BulletPointsEmptyIcon;
